import { useEffect } from 'react'
import { useWorld } from '../hooks/use-world'

// Registers a non-moving, non-solid entity in the world sprite map.
// All game logic for each type lives in the player/collision hooks that scan spritesRef.
export const StaticEntity = ({ x, y, width, height, entityType, config = {} }) => {
  const { addSprite, removeSprite, currentLevel } = useWorld()
  const cfg = { solid: false, ...config, entityType, level: currentLevel }

  useEffect(() => {
    addSprite({ id: cfg.id, x, y, width, height, config: cfg })
    return () => removeSprite({ id: cfg.id })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}
